export { useFocusAPI } from './useFocusAPI';
export { useBatchAPI } from './useBatchAPI';
export { useFeedApi } from './useFeedApi';
export { useMultipleFeedApi } from './useMultipleFeedApi';
export { useNavConfig } from './useNavConfig';
export { useArticlePvAPI } from './useArticlePvAPI';
export { useFooterMapConfig } from './useFooterMapConfig';



// WEBPACK FOOTER //
// ./src/hooks/APIs/index.ts